import type { OfflineManifest } from '@floorfile/contracts'
/** D24 addendum (FF-AUDIT-089, owner decision 2026-09-13): minting a sign token
 * (`reauth`) and chain verification stay online, but a host action in Part 11
 * scope may be SIGNED offline on a device that holds an offline signing
 * credential — the password unseals the credential, and the server applies the
 * signature on sync (OFFLINE_&_MOBILE_RESILIENCE.md §11). */
export const esignOfflineManifest: OfflineManifest = {module:'regulated_esign',entities:['esign_audit'],actions:[],conflictPolicy:'server-review-required',requiresOnline:['reauth','verify']}
